export function getFocusableSelector() {
  return 'a, button, input, textarea, select, iframe, form, label, object, embed, svg, keygen, video';
}


// WEBPACK FOOTER //
// ./assets/js/modules/get-focusable-selector.js